module.exports = __webpack_public_path__ + "static/media/yellow-signs-home-tiny.3f218cbf.jpg";